import { render, staticRenderFns } from "./IndexArticleModal.vue?vue&type=template&id=496fd820&scoped=true"
import script from "./IndexArticleModal.vue?vue&type=script&lang=js"
export * from "./IndexArticleModal.vue?vue&type=script&lang=js"
import style0 from "./IndexArticleModal.vue?vue&type=style&index=0&id=496fd820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496fd820",
  null
  
)

export default component.exports